import * as actionTypes from "./BPMasterType";

const INITIAL_STATE = {
  ComplaintsList: null,
  ComplaintsListById: {},
  ComplaintsListData: {},
  ProductCategoryList: {},
  ComplaintsCategoryList: [],
  customerList: [],
  complaintsCount: [],
  customerInvoiceList: [],
  customerItemList: [],
  bpMasterList: [],
  bpMasterById: {},
  customerGroup: [],
  currency: [],
  series: [],
};

const BPMasterReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SETCOMPLAINTSLIST:
      return {
        ...state,
        ComplaintsList: action.payload,
      };
    case actionTypes.SETBPMASTERLIST:
      return {
        ...state,
        bpMasterList: action.payload,
      };
    case actionTypes.SETBPMASTERBYID:
      return {
        ...state,
        bpMasterById: action.payload,
      };
    case actionTypes.SETCUSTOMERGROUP:
      return {
        ...state,
        customerGroup: action.payload,
      };
    case actionTypes.SETCURRENCY:
      return {
        ...state,
        currency: action.payload,
      };
    case actionTypes.SETSERIES:
      return {
        ...state,
        series: action.payload,
      };
    default:
      return state;
  }
};

export default BPMasterReducer;
